export const labels = {
  userDisabled: "Account is Disabled",
  userLoggingIn: "Loading...",
  loading: "Loading...",
  disabled: "Disabled",
  save: "Save",
  cancel: "Cancel",
  close: "Close",
  clear: "Clear",
  default: "Default",
  discardChanges: "Discard Changes",
  filteredBy: "Filtered By",
  dataPositionFormatString: "{0:n0}-{1:n0} of {2:n0}",
  branding: {
    title: "Olive Tree Escapes"
  },
  never: "never",
  none: "None",
  retired: "retired",
  required: "Required",
  keywords: "Keywords",
  options: "Options",
  daily: "Daily",
  notifications: {
    invalidDownloadUrl: "Invalid or empty download URL.",
    contactSelected: "Contact added",
    primaryContactSet: "Primary contact updated",
    addedFormatString: "Added {0}",
    savedFormatString: "Saved {0}",
    accessExceptionGrantedFormatString: "Access granted to {0}",
    accessExceptionRevokedFormatString: "Access revoked for {0}",
    removedClientFormatString: "{0} (client) removed",
    removedAgentFormatString: "{0} (agent) removed",
    locationAssignedFormatString: "{0} assigned to {1:d}",
    locationInvalidFormatString: "Invalid location for {0:d}",
    revisionCreatedFormatString: "New version for {0} created",
  },
  daysOfWeek: [
    {
      value: 1,
      label: "Monday",
    },
    {
      value: 2,
      label: "Tuesday",
    },
    {
      value: 3,
      label: "Wednesday",
    },
    {
      value: 4,
      label: "Thursday",
    },
    {
      value: 5,
      label: "Friday",
    },
    {
      value: 6,
      label: "Saturday",
    },
    {
      value: 0,
      label: "Sunday",
    },
  ],
  bookingStatus: [
    {
      label: "Requested",
      value: "requested",
    },
    {
      label: "Own Arrangements",
      value: "na",
    },
    {
      label: "Confirmed",
      value: "confirmed",
    },
    {
      label: "Voucher Sent",
      value: "voucher-sent",
    },
    {
      label: "Voucher Confirmed",
      value: "voucher-confirmed",
    },
    {
      label: "Canceled",
      value: "canceled",
    },
  ],
  actions: {
    grantPermissions: "Share",
    removeAccess: "Remove Access",
    removeContact: "Remove",
    refreshData: "Refresh data",
    select: "Select",
    chooseOne: "Choose One",
    previous: "Previous",
    next: "Next",
    printProposal: "Proposal",
    printVouchers: "Vouchers",
    printInvoice: "Download PDF",
    printVoucher: "Download PDF",
    save: "Save",
    saveAndContinue: "Save & Continue Editing",
    edit: "Edit",
    view: "Details",
    delete: "Delete",
    remove: "Remove",
    cancel: "Cancel",
    setDefault: "Set as Default",
    clearPrimaryImage: "Remove as Primary",
    copiedToClipboard: "Copied to clipboard!",
  },
  navigation: {
    trips: {
      tooltip: "Trips",
    },
    ops: {
      tooltip: "Operations",
      label: "Operations",
    },
    suppliers: {
      tooltip: "Suppliers",
    },
    packages: {
      tooltip: "Templates",
    },
    services: {
      tooltip: "Services",
    },
    contacts: {
      tooltip: "Contacts",
    },
    mediaLibrary: {
      tooltip: "Media Library",
    },
    locations: {
      tooltip: "Countries & Regions",
    },
    users: {
      tooltip: "Users",
    },
    settings: {
      tooltip: "Settings",
    },
  },
  settings: {
    h1: "Application Settings",
    save: "Save",
    tabs: {
      currencyFees: "Currency &amp; Fees",
      termsConditions: "Terms &amp; Conditions",
      media: "Media",
    },
    exchangeRate: {
      label: "Exchange Rate",
      placeholder: "1.00"
    },
    creditCardSurcharge: {
      label: "Credit Card Fee",
      placeholder: "3.25"
    },
    agentCommission: {
      label: "Agent Commission",
      placeholder: 15
    },
    markup: {
      label: "Markup",
      placeholder: "10"
    },
    termsConditions: {
      label: "Terms &amp; Conditions",
      placeholder: "Complete terms & conditions displayed in proposal",
      proposalTerms: "Proposal",
      proposalTermsHelp: "This text is used in every proposal on the final Terms &amp; Conditions page when printed to PDF.",
      serviceTerms: "Voucher (default)",
      serviceTermsHelp: "This text is used in on each voucher's Terms &amp; Conditions section at the bottom of each service voucher.",
      transportationTerms: "Transportation",
      transportationTermsHelp: "This text is used on transportation/transfer vouchers in the Delay Policy section.",
    },
    defaultCoverImage: {
      label: "Default Cover Page Image",
      altText: "Default cover image for proposals"
    },
    defaultHeaderImage: {
      label: "Default Page Header Image",
      altText: "Default page header image for proposals"
    },
    locations: {
      countryName: {
        placeholder: "Country Name",
      },
      countryAbbreviation: {
        placeholder: "ISO3",
        placeholder2: "ISO2"
      },

      regionName: {
        placeholder: "Region Name",
      },
      regionAbbreviation: {
        placeholder: "ISO2"
      }
    },
  },
  agentSearch: {
    header: "Travel Agent",
  },
  secondaryContactSearch: {
    header: "Alternate Contact",
  },
  participantSearch: {
    header: "Client",
  },
  planner: {
    actions: {
      setPrimary: "Highlight activity",
      clearPrimary: "Remove highlighting",
      emailBookingRequest: "Booking Request Email",
      linkedReservation: "Create Linked Reservation",
      reverseItinerary: "Reverse Itinerary",
    },
    new: {
      label: "Create a new trip",
      tooltip: "New Trip",
    },
    messages: {
      confirmAddActivity: "Are you sure?\nThe proposal's total is being overridden and a new service may cause the proposal to be underfunded.",
      confirmRemoveOverride: "You have added a new service. Would you like to clear the proposal total override?",
      confirmRemoveHotel: "Are you sure?\nRemoving this hotel will remove it from the current itinerary version.",
      confirmRemoveActivity: "Are you sure?\nRemoving this service will remove it from the current itinerary version.",
    },
    errors: {
      cityOutsideDuration: "Warning: Planned city is outside the specified duration for this trip."
    },
    lock: {
      lockedByFormatString: "This trip is locked by {0}",
      unlock: "Unlock",
    },

    options: {
      summary: "All options/overrides for this proposal are summarized here. You can change the values here if anything does not match.",
      depositPaid: "Deposit Paid",
      finalized: "Finalized",
      excludePricing: "Exclude Pricing",
      whiteLabel: "Whitelabel",
    },

    updateAgent: "Update Agent",
    addAgent: "Assign Travel Agent",
    addParticipant: "Add Client",
    addHotel: "Add Another Hotel",
    removeHotel: "Remove this Hotel",
    addActivity: "Add Another Activity",
    removeActivity: "Remove this activity",
    removeCity: "Delete this city",
    searchContacts: "Search...",
    searchAgents: "Find an Agent...",
    searchSecondaryContact: "Assign secondary contact",
    returnTooltip: "Back to Trip Listing",
    markDepositPaid: "Mark Deposit Paid",

    headingOperationsOptions: "Operations",
    headingPrintOptions: "Proposal Print Options",
    headingSecondaryContact: "Alternate Contact",
    headingSecondaryContactType: "Type of Contact",
    headingSecondaryContactOther: "Other",
    headingAgent: "Agent",
    headingBillTo: "Bill To",
    headingContacts: "Client(s)",
    headingTravelDates: "Travel Dates",
    headingLineItem: "Location / Activities",
    headingPassengerCount: "PAX",
    headingPassengers: "# Passengers",
    headingPassengerName: "Name",
    headingDescription: "Description",
    headingSubtotal: "Subtotal",
    headingTotal: "Total",
    headingCommission: "Commission",
    headingType: "Type",

    listing: {
      headerTripName: "Trip",
      headerOwner: "Team Member",
      headerCountries: "Country",
      headerDateDeparture: "Arrival Date",
      headerDateReturn: "Departure Date",
      headerDuration: "Days",

      defaultTripName: "New Trip Proposal",

      filterFinal: {
        label: "Finalized Only"
      },

      filterSalesTeam: {
        label: "Team Member"
      },

      filterRegion: {
        label: "Region(s)"
      },

      filterCountry: {
        label: "Country(s)"
      },

      emptyMessage: "No trips match the current search criteria",
    },
    accessControl: {
      labelOwner: "Owner",

      newUser: {
        label: "Grant Access to",
        placeholder: "Search...",
        help: "Search for users by name/email and grant write access"
      }
    },
    secondaryContactType: {
      driver: {
        label: "Driver",
        value: "driver"
      },
      guide: {
        label: "Guide",
        value: "guide"
      },
      combo: {
        label: "Driver/Guide",
        value: "driver/guide"
      },
      host: {
        label: "Host",
        value: "host"
      },
      other: {
        placeholder: "i.e. John Smith",
      },
    },
    revisions: {
      baseline: "Baseline",
      label: "Current Revision",
      draft: "Draft",
      newDraft: "Set Baseline",
      newRevision: "New Revision",
      labelFormat: "Revision {0:n0}",

      messages: {
        confirmCreateVersion: "Are you sure you want to create a new version?",
      },
    },
    builder: {
      tabCities: "Cities",
      tabHotels: "Hotels",
      tabServices: "Activities",
      tabItinerary: "Itinerary",
      tabOperations: "Operations",
      tabInvoice: "Invoice",

      filterClear: "View All",
      filterHotels: "Accommodations",
      filterServices: "Services",

      headerContacts: "Client(s)",

      headerActivities: "Activities",
      headerCity: "City",
      headerHotel: "Hotel",
      headerSupplier: "Supplier",
      headerDateScheduled: "Date",
      headerCheckInDate: "Check-In",
      headerCheckOutDate: "Check-Out",
      headerTotalNights: "Nights",
      headerTimeframe: "Daytime",
      headerTime: "Time",
      headerEndsAt: "Ends",
      headerHeadCount: "Qty",
      headerService: "Product",
      headerVehicleCount: "# Vehicles",
      headerGroupCount: "# Groups",
      headerRoomStyle: "Room Type",
      headerRoomCount: "# Rooms",
      headerPeopleCount: "# People",
      headerRoomOccupancy: "# People",
      headerNetPrice: "Net Price",
      headerExchangeRate: "Exchange",
      headerMarkup: "Markup %",
      headerPrice: "Price",
      headerFees: "Fees",
      headerEditService: "Edit Service",

      labelSubtotal: "Subtotal",

      tooltipCopyCity: "Copy previous location",
      tooltipPrependTravelDay: "Add Travel Day Before",
      tooltipAppendTravelDay: "Add Travel Day After",

      emptyService: "Not specified",
      emptyStartTime: "TBD",
    },
    invoice: {
      agentCommissionPercentFormat: "{0:p} Travel Agent Commission",
      agentCommissionAmountFormat: "Total Owed to Travel Agent ({0:d})",
      paid: "Paid",
      defaultDescription: "FIT",
      defaultDescriptionFormat: "Default: {0}",

      number: {
        label: "#",
        placeholder: 'i.e. ' + (new Date()).getFullYear() + '-00000',
      },

      dateAgentInvoice: {
        label: "Date of Issue",
        placeholder: 'Not Set',
      },

      commissionOverride: {
        label: "Commission Amount",
        placeholder: '{0:p}',
      },

      messages: {
        confirmDepositPaid: "Mark this deposit paid?\n\nDoing so will lock the current pricing.",
        confirmUnlockPayment: "Re-open this proposal?\n\nDoing so will allow further changes by anyone with access.",

        confirmOpenItinerary: "Mark this itinerary as tentative?\n\nDoing so will prevent operations from working on bookings that may already be in progress and recalculate line item pricing.",
        confirmFinalItinerary: "Mark this itinerary as final?\n\nDoing so will allow operations to work on bookings and lock in current pricing.",

        errorMissingData: "Set all the following: agent, invoice number, and date of issue.",
      }
    },
    keywordSearch: {
      placeholder: "Search...",
    },
    dayChooser: {
      placeholder: "Choose...",
    },
    dateDeparture: {
      short: "Arrives",
      label: "Arrival Date",
      placeholder: "mm/dd/yyyy",
    },
    dateReturn: {
      short: "Departs",
      label: "Departure Date",
      placeholder: "mm/dd/yyyy",
    },
    duration: {
      label: "Duration",
      suffix: "days",
      format: "{0} days",
    },
    timeScheduled: {
      label: "Duration",
      suffix: "days",
      format: "{0} days",
      placeholder: "n/a",
    },
    confirmationNumber: {
      label: "Confirmation #",
      placeholder: "i.e. ABC123"
    },
    clientName: {
      label: "Client Name",
    },
    clientContactPhone: {
      label: "Client Contact Info",
      defaultPlaceholder: "No Phone #",
    },
    bookingStatus: {
      label: "Booking Status",
      placeholder: "New"
    },
    pickupLocation: {
      label: "Pickup",
      placeholder: "Address or Location"
    },
    dropoffLocation: {
      label: "Drop-Off",
      placeholder: "Address or Location"
    },
    proposalAmount: {
      label: "Proposal Total",
      placeholder: "$0.00",
    },
    assistedBy: {
      label: "Assistance in Europe",
      placeholder: "Not Assigned",
      helpText: "Operations user assigned to provide traveler assistance during the trip. Contact information is displayed on the voucher.",
    },
    overrideAmount: {
      label: "Calculated Total",
      placeholder: "$0.00",
    },
    service: {
      primary: "Highlight",
      placeholder: "Search services",
      pageBreak: "Page Break",
      pageBreakNone: "none",
      pageBreakBefore: "before",
      pageBreakAfter: "after",
    },
  },
  ops: {
    actions: {
      cloneService: "Copy {0}",
    },
    services: {
      timeScheduled: "Time",
      name: "Product",
      headCount: "PAX",
      bookingStatus: "Status",
      confirmationNumber: "Conf #",
    },
    bookingStatus: {
      default: "New"
    }
  },
  fees: {
    action: {
      add: "Add Fee",
    },

    headerLabel: "Description",
    headerType: "Type",
    headerRate: "Rate",
    headerAmount: "Amount",

    sectionHeading: "Fees",
    creditCard: {
      label: "Credit Card",
      value: "credit-card",
    },
    other: {
      label: "Misc",
      value: "other",
    },
  },
  comments: {
    actions: {
      leaveComment: "Add a Note",
    },
    sectionHeading: "Notes",
    formHeading: "Add a Note",
    from: "By:",
    search: {
      placeholder: "Search...",
    },
    content: {
      placeholder: "Say what you need to say...",
    },
    loadMore: "Load More",
  },
  suppliers: {
    cancel: "Discard Changes",
    save: "Save",
    new: "New Supplier",
    search: {
      placeholder: "Search...",
    },
    actions: {
      searchTags: "Add a keyword..."
    },
    listing: {
      header: "Suppliers",
      headerName: "Supplier",
      headerAddress: "Address",
      headerCity: "City",
      headerRegion: "Region",
      headerState: "State",
      headerCountry: "Country",
      headerPhone: "Phone",
      headerPhoneMobile: "Phone (Mobile)",
      headerPhoneTollFree: "Toll Free",
      headerMedia: "Media",

      emptyMessage: "No suppliers match the current search criteria",

      labelStreetAddress: "Street Address",
      labelMailingAddress: "Mailing Address",

      labelCompany: "Company",
      labelHost: "Host",

      filterCountry: {
        label: "Country(s)",
        placeholder: "Select 1+",
      },
      filterRegion: {
        label: "Region(s)",
        placeholder: "Select 1+",
      },
      filterCity: {
        label: "City(s)",
        placeholder: "Search...",
      },
    },

    headingDescription: "Description",
    headingInclusions: "Service Description",
    headingExclusions: "Exclusions/Special Instructions",
    headingHotels: "Hotels",
    labelCheckIn: "Check-In Time",
    labelCheckOut: "Check-Out Time",

    messages: {
      confirmDeleteSupplier: "Archive this supplier?",
    },
  },
  packages: {
    cancel: "Discard Changes",
    save: "Save",
    search: {
      placeholder: "Search...",
    },
    actions: {
      addNew: "Create a Package",
      bundleService: "Add Another Service",
      searchSuppliers: "Search Suppliers...",
      searchServices: "Search Services...",
      searchHotels: "Search Hotels...",
    },

    fields: {
      name: {
        placeholder: "Template Name",
      },
      supplier: {
        placeholder: "Supplier",
      },
    },

    labels: {
      pricing: "Combined Price",
      keywords: "Keywords",
    },

    listing: {
      header: "Templates",
      headerName: "Template",
      headerPrice: "Price",
      headerServiceType: "Category",
      headerServices: "Services",
      headerService: "Service",
      headerCountry: "Country",

      emptyMessage: "No packages match the current search criteria",

      labels: {
        name: "Name",
        description: "Description",
        price: "Price",
        exchangeRate: "Exchange Rate",
        services: "Services Included"
      },
    }
  },
  contacts: {
    cancel: "Discard Changes",
    save: "Save",
    new: "New Contact",
    search: {
      placeholder: "Search...",
    },
    type: {
      agent: {
        label: "Agent",
        value: "agent",
      },
      contact: {
        label: "Client",
        value: "contact",
      },
      supplier: {
        label: "Supplier",
        value: "supplier",
      },
    },
    listing: {
      header: "Contacts",
      headerName: "Name",
      headerEmail: "Email Address",
      headerPhone: "Phone",
      headerBirthDate: "Birth Date",
      headerType: "Type",
      headerBillingInformation: "Billing Information",
      headerBillingAddress: "Mailing Address",
      headerBillingCity: "City",
      headerBillingState: "State",
      headerBillingPostalCode: "Post Code",

      labelCompany: "Company",
      labelAlternatePhone: "Alternate Phone",

      emptyMessage: "No contacts match the current search criteria",
    },

    fieldCommissionOverride: {
      label: "Rate",
    },

    messages: {
      confirmDelete: "Are you sure?\n\nRemoving this contact means that no one will be able to use it in future proposals.",
    },
  },
  services: {
    viewFormatString: "View: {0}",
    editFormatString: "Edit: {0}",
    cloneFormatString: "Clone: {0}",
    deleteFormatString: "Archive: {0}",
    restoreFormatString: "Restore: {0}",
    cancel: "Discard Changes",
    save: "Save Changes",
    voucher: "Voucher",
    labelOpenScheduling: "Open Schedule",
    labelAvailability: "Availability",
    confirmationNumberRecommended: [
      "confirmed",
      "voucher-sent",
      "voucher-confirmed",
    ],
    new: {
      tooltip: "New Service",
      label: "New Service"
    },
    search: {
      placeholder: "Search...",
    },
    actions: {
      addNew: "Add New Service",
      searchTags: "Add keyword...",
      searchSuppliers: "Search Suppliers...",
      searchServices: "Search Services...",
      searchHotels: "Search Hotels...",
      chooseTime: "Choose...",
    },
    listing: {
      header: "Services",
      headerName: "Name",
      headerCountry: "Country",
      headerCurrentPrice: "Current Price",
      headerSupplier: "Supplier",
      headerType: "Type",
      headerMedia: "Media",

      emptyMessage: "No services match the current search criteria",

      filterSupplier: {
        label: "Supplier(s)",
        placeholder: "Select 1+",
      },
      filterType: {
        label: "Type(s)",
        placeholder: "Select 1+",
      },
      filterCountry: {
        label: "Country(s)",
        placeholder: "Select 1+",
      },
      filterRegion: {
        label: "Region(s)",
        placeholder: "Select 1+",
      },
      filterCity: {
        label: "City(s)",
        placeholder: "Search...",
      },
      filterArchive: {
        label: "View Archive",
      },
    },

    headingDescription: "Proposal Description",
    headingInclusions: "Included",
    headingVoucherDescription: "Service Description",
    headingExclusions: "Not Included",
    headingSpecialInstructions: "Special Instructions",

    emptyDescription: "Use from service",
    emptyInclusions: "Use from service",
    emptyExclusions: "Use from service",

    pricing: {
      create: "New Season",
      clonePrice: "Copy Season",
      addThreshold: "New Level",
      levels: "Levels",
      showPricingFor: "Show pricing for",

      headerPrice: "Price",
      headerServiceClass: "Service Class",
      headerPriceType: "Pricing Type",
      headerMinimumQuantity: "Min Qty",
      headerValidFrom: "Valid From",
      headerValidTo: "To",

      minimumQuantity: {
        placeholder: "Min: 1",
      },
      type: {
        individual: {
          value: "per-person",
          label: "Per Person",
        },
        group: {
          value: "per-group",
          label: "Per Group",
          lineItem: "Group Pricing",
        }
      },
    },
    children: {
      label: "Bundled Services",
      parentBadge: "Primary Service",
      badge: "Bundled",
      subtotal: "Bundled Subtotal",
    },
    netPrice: {
      label: "Net",
      usd: "Net (USD)",
      euro: "Net (Euro)",
    },
    dateValidFrom: {
      placeholder: "Valid From",
    },
    dateValidTo: {
      label: "Valid Thru",
    },
    customerLabel: {
      label: "Customer Label",
      placeholder: "i.e. Luxury Wine Tasting Experience",
      helpText: "Substituted for service name on customer proposals and vouchers when set."
    },
    classifications: {
      label: "Class of Service Options",
      placeholder: "i.e. 'Sedan' or 'Executive'",
    },

    warnings: {
      pricingNotAvailable: "Pricing is not available for {0:d}",
      pricingNotAvailableGeneral: "Pricing is not available"
    },

    messages: {
      errorRemoveHotel: "Accommodations could not be deleted",
      errorRemoveActivity: "Service could not be deleted",
      confirmDeleteService: "Archive this service?",
      confirmRestoreService: "Restore this service: {0}?",
      confirmCloneService: "Copy service: {0}?",
      confirmDeleteThreshold: "Delete the threshold?",
      confirmDeletePrice: "Delete the pricing term?",
      confirmDeleteClassification: "Remove this class of service?",
      confirmPricingTypeChange: "Change this pricing type?\n\nChanging group pricing when you have more than one threshold will result in the loss of current volume pricing thresholds.",
    },
  },
  mediaLibrary: {
    h1: "Media Library",
    uploadModal: {
      header: "Upload Image",
      name: {
        placeholder: "i.e. Coastal View",
        label: "Title"
      },
      cancel: "Discard Changes",
      save: "Upload File",
      fileTooLarge: "File is too large. Maximum size is {0} MB.",
    },
    browserModal: {
      header: "Media Library",
      cancel: "Close",
      upload: "Upload",
    },

    actions: {
      upload: "Upload new image",
      searchTags: "Add keyword...",
    },
    search: {
      placeholder: "Search",
    },

    messages: {
      confirmDeleteAsset: "Are you sure?\n\nDeleting an image cannot be undone."
    },
  },
  userManager: {
    actions: {
      addNew: "New User"
    },
    table: {
      headerFullName: "User",
      headerUsername: "Email Address",
      headerPhone: "Phone #",
      headerRoles: "Roles",

      emptyDataMessage: "No users to show"
    },
    search: {
      placeholder: "Search...",
    },
    fullName: {
      placeholder: "i.e. John Smith",
      label: "Full Name",
    },
    emailAddress: {
      placeholder: "i.e. john@smith.net",
      label: "Email Address",
    },
    phone: {
      placeholder: "i.e. +39 444 1212",
      label: "Phone #",
    },
    options: {
      label: "User options menu",
      changeRole: "User Roles",
      promoteToPackageManager: "Promote to Package Manager",
      revokePackageManager: "Revoke Package Manager role",
    }
  },
}
